/** 账户页列表前端分页，每页条数上限 */
export const ACCOUNT_TABLE_PAGE_SIZE = 10;

export const accountTablePagination = (total: number) => ({
  pageSize: ACCOUNT_TABLE_PAGE_SIZE,
  total,
  showSizeChanger: false,
  hideOnSinglePage: true,
});
